import React from 'react';
import PropTypes from 'prop-types';

function RequestStatus({ loading, error, onRetry }) {
  if (loading) {
    return <p className="request-status" role="status">Loading your quote…</p>;
  }
  if (!error) return null;
  return (
    <div className="request-status alert alert-danger" role="alert">
      <p>{error}</p>
      <button type="button" className="btn btn-primary" onClick={onRetry}>Retry</button>
    </div>
  );
}

RequestStatus.propTypes = {
  loading: PropTypes.bool,
  error: PropTypes.string,
  onRetry: PropTypes.func,
};
export default RequestStatus;
